var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "3100",
                  reset: true,
                  "custom-search-items": _vm.customSearchItems,
                  "custom-sim-query-placeholder": _vm.$t(
                    "Message.QuickSearchBusinessNo"
                  )
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.isAdvancedQuery = value)
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery,
                  advSearchItemResetCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.routeConfirmationHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(this.$t("CargoMsg.Cargo_RouteConfirmation")) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.cancelRouteConfirmationHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            this.$t("CargoMsg.Cargo_Cancel") +
                              this.$t("CargoMsg.Cargo_RouteConfirmation")
                          ) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.bookingCompletionHandler(1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(this.$t("CargoMsg.Cargo_BookingCompletion")) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.bookingCompletionHandler(0)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            this.$t("CargoMsg.Cargo_Cancel") +
                              this.$t("CargoMsg.Cargo_BookingCompletion")
                          ) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.secondaryConfirmationHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            this.$t("CargoMsg.Cargo_SecondaryConfirmation")
                          ) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.cancelSecondaryConfirmationHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            this.$t("CargoMsg.Cargo_Cancel") +
                              this.$t("CargoMsg.Cargo_SecondaryConfirmation")
                          ) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.routeMarkingHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(this.$t("CargoMsg.Cargo_RouteMarking")) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.flightReassignmentHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(this.$t("CargoMsg.Cargo_FlightReassignment")) +
                            " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "250522",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "deselect-sub-record": true
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "250521",
                    total: _vm.filter.total,
                    "page-count": _vm.pageCount,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.routeDetailWindow.visible
        ? _c("route-detail", {
            ref: "routeDetail",
            attrs: {
              visible: _vm.routeDetailWindow.visible,
              rows: _vm.routeDetailWindow.rows,
              title: _vm.routeDetailWindow.title,
              "job-uuid": _vm.routeDetailWindow.jobUuid,
              "secondary-confirmation":
                _vm.routeDetailWindow.secondaryConfirmation
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.routeDetailWindow, "visible", $event)
              },
              close: function($event) {
                _vm.routeDetailWindow.visible = false
              },
              refresh: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.changeDataWindow.visible
        ? _c("change-data-window", {
            attrs: {
              visible: _vm.changeDataWindow.visible,
              uuids: _vm.changeDataWindow.uuids,
              type: _vm.changeDataWindow.type,
              title: _vm.changeDataWindow.title
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.changeDataWindow, "visible", $event)
              },
              close: function($event) {
                _vm.changeDataWindow.visible = false
              },
              refresh: _vm.toQuery
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }